<template>
    <div class=" border rounded shadow p-1 p-md-2 p-lg-3">
       <div class="row">
            <div class="col-md-2 col-sm-12 font-weight-bold">Title</div><div class="col" ><input class="form-control p-0" v-on:change="update('Title')" v-model="stream.Title"/></div>
            <div class="col-md-2 col-sm-12 font-weight-bold">Description</div><div class="col" ><textarea class="form-control p-0" v-on:change="update('Description')" v-model="stream.Description"/></div>
       </div>
       <div class="row">   
            <div class="col-md-2 col-sm-12 font-weight-bold">Contact</div><div class="col" ><input class="form-control p-0" v-on:change="update('Contact')" v-model="stream.Contact"/></div>
            <div class="col-md-2 col-sm-12 font-weight-bold">Email</div><div class="col" ><input class="form-control p-0" v-on:change="update('Email')" v-model="stream.Email"/></div>
        </div>
       <div class="row">  
            <div class="col-md-2 col-sm-12 font-weight-bold">Password</div><div class="col" ><input class="form-control p-0" v-on:change="update('password')" v-model="stream.password"/></div>
            <div class="col-md-2 col-sm-12 font-weight-bold">Start Time </div><div class="col" ><input class="form-control p-0" v-on:change="update('Start_Time')" v-model="stream.Start_Time"/></div>
        </div>
       <div class="row">  
            <div class="col-md-2 col-sm-12 font-weight-bold">Stream URL</div><div class="col" ><input class="form-control p-0" v-on:change="update('Server')" v-model="stream.Server" /></div>
            <div class="col-md-2 col-sm-12 font-weight-bold">Stream Key</div><div class="col" ><input class="form-control p-0" v-on:change="update('Stream_Key')" v-model="stream.Stream_Key"/></div>
            </div>
       <div class="row">  
            <div class="col-md-2 col-sm-12 font-weight-bold">Resource<small>Encoder Stream Key</small></div><div class="col" ><input class="form-control p-0" v-on:change="update('Resource')" v-model="stream.Resource"/></div>
            <div class="col-md-2 col-sm-12 font-weight-bold">Active</div><div class="col" contenteditable v-on:change="update('Title')"><input v-on:change="update('Active')" :id="stream.id + '_Active'" type="checkbox"  v-model="stream.Active"/></div>
        </div>
        <div class="row">   
            <div class="col-md-2 col-sm-12 font-weight-bold">UID</div><div class="col" ><input class="form-control p-0" v-on:change="update('UID')" v-model="stream.UID"/></div>
            <div class="col-md-2 col-sm-12 font-weight-bold">Embed URL</div><div class="col" ><input class="form-control p-0" v-on:change="update('URL')" v-model="stream.URL"/></div>
        </div>
       <div class="row">  
            
           <div class="col-6"><b-button class="btn-sm" variant="danger" v-on:click="_delete()">Delete</b-button></div>
           <div class="col-md-2 col-sm-12 font-weight-bold">Share URL</div><div class="col" ><small><a target="_blank" v-bind:href="'https://aperturefilms.com.au/live?s=' + stream.UID">https://aperturefilms.com.au/live?s={{stream.UID}}</a></small></div>
       </div>
        <b-alert class="m-2"
      :show="dismissCountDown"
      dismissible
      fade
      :variant="variant"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
    >
      {{responseMSG}}
    </b-alert>
    </div>       
</template>

<script>
/* eslint-disable */ 
export default {
    name: "streamEdit",
    data() {
        return {
            dismissSecs: 2,
            dismissCountDown: 0,
            variant: 'success',
            responseMSG: ''
        }
    },
    props: {
        stream:{}
    },
    methods:{
        update(el){
            let currentObj = this;
            let params = new URLSearchParams();
            params.append('field', el);
            params.append('value', this.stream[el])
            params.append('id', this.stream.id)
            params.append('task', 'editStream');
            this.axios.post('https://www.aperturefilms.com.au/customer-portal/admin.php', params)
                .then(function (response) {
                    console.log(response.data)
                    if (response.data.success) {
                        currentObj.showAlert("success", "Event Updated")
                    } else {
                        currentObj.showAlert("danger", "Event NOT Updated, try refreshing page")
                    }

                     
                })
                .catch(function (error) {
                    console.log(error);  
                });
      },
        _delete(){
            let currentObj = this;
            let params = new URLSearchParams();
            params.append('id', this.stream.id)
            params.append('task', 'deleteStream');
            this.axios.post('https://www.aperturefilms.com.au/customer-portal/admin.php', params)
                .then(function (response) {
                    console.log(response.data)
                    if (response.data.success) {
                        currentObj.$emit("refresh");
                    }
                })
                .catch(function (error) {
                    console.log(error);  
                });
        },
      
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
        },
        showAlert(type, msg) {
            this.responseMSG = msg
            this.variant = type
            this.dismissCountDown = this.dismissSecs
        }
    }

}
</script>
    
